// Generic global storage held only in javascript memory.

type Storage = Record<string, any>;

let storage: Storage = {};

const getItem = (key: string) =>  storage[key];

const setItem = (key: string, value: any) => { storage[key] = value; };

const removeItem = (key: string) => { delete storage[key]; };

export default {
    getItem,
    setItem,
    removeItem
};